import { AbstractCommand } from "./AbstractCommand"
import { CommandResponse } from "../types"
import { getSequenceId } from "../utils/sequenceIdManager"

/**
 * Valid AMS control actions
 */
export enum AMSControlAction {
  RESUME = "resume",
  RESET = "reset",
  PAUSE = "pause",
  DONE = "done"
}

export class AMSControlCommand extends AbstractCommand {
  public readonly category = "print"
  public readonly command = "ams_control" as const

  constructor({
    action
  }: {
    action: AMSControlAction
  }) {
    super({
      param: action
    })
  }

  ownsResponse(response: CommandResponse, sequence_id?: string): boolean {
    if (!("print" in response)) {
      return false
    }

    const printResponse = response as { print: { sequence_id?: string | undefined } }
    const responseId = printResponse.print?.sequence_id
    const extraId = this.extra?.sequence_id

    if (!responseId) {
      return false
    }

    if (sequence_id && responseId === sequence_id) {
      return true
    }

    if (extraId && responseId === extraId) {
      return true
    }

    return false
  }
}